import { APIBinderData } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import {
  countPrincipalDrivers,
  processValidation,
  validateFailedObjects,
} from '../utils/helpers';

export const processPrincipalDriverAssignmentData = (
  binderReportData: APIBinderData,
  validation?: Validation,
  remarks: Remark[] = [],
): BinderSectionData => {
  const quoteData = binderReportData?.quote_data;
  const drivers = quoteData?.drivers;

  const driverRows = drivers.map((driver, index: number) => {
    const isValid = validateFailedObjects(index, validation);

    return {
      driverName: driver?.name || '',
      principalOnVehicleCount: countPrincipalDrivers(quoteData, driver),
      remarks:
        remarks.find((r) => r.item_key === `driver-${index + 1}`)?.text || '-',
      isValid: validation ? isValid : true,
    };
  });

  const validationData = processValidation(validation);

  return {
    title: 'Principal driver assignment',
    description: 'Verify principal driver assignments for all vehicles.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      driverRows,
    },
  };
};
